module.exports = __webpack_public_path__ + "img/what_s_missing_illustration.120eca70.svg";